import api from '@/js/services/api';

export default {

    //pages

    fetchListOfPages() {
        return api().get(`/admin/panel/pages/get`);
    },
    deletePage(pageId) {
        return api().delete(`/admin/panel/pages/${pageId}/delete`);
    },

    getPageFields(page_id) {
        return api().get(`/admin/panel/pages/${page_id}/get`);
    },

    uploadFilesForPages(page_id,file) {
        return api().post(`/files/pages/${page_id}/upload`, file);
    },

    uploadLogo(file) {
        return api().post(`/files/pages/upload`, file);
    },

    updatePage(page_id, info) {
        return api().put(`/admin/panel/pages/${page_id}/update`, info);
    },


    //menus
    fetchListOfMenus() {
        return api().get(`/admin/panel/menus/get`);
    },

    deleteMenu(menuId) {
        return api().delete(`/admin/panel/menus/${menuId}/delete`);
    },

    deleteMenuItem(itemId) {
        return api().delete(`/admin/panel/menu/item/${itemId}/delete`);
    },

    fetchMenuInnerItems(menuId) {
        return api().get(`/admin/panel/menus/${menuId}/get`);
    },

    changeMenuTitle(menuId, name) {
        return api().put(`/admin/panel/menus/${menuId}/update`, {name});
    },

    updateMenuItems(menuId, form) {
        return api().post(`/admin/panel/menu/${menuId}/item/edit`, form);
    },

    updateMenuItemsOrder(ids) {
        return api().post(`/admin/panel/menu/items/sort`, {ids});
    },



    //news

    fetchNewsInfo(articleId) {
        return api().get(`/admin/panel/news/${articleId}/get`);
    },

    fetchListOfNews(filters) {
        const searchParams = new URLSearchParams();
        for( const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/admin/panel/news/get?` + searchParams.toString())
    },


    deleteNews(newsId) {
        return api().delete(`/admin/panel/news/${newsId}/delete`);
    },

    deleteFewNews(ids) {
        return api().delete(`/admin/panel/news/bulkDelete`, {
            params: {ids}
        });
    },

    createNews(info) {
        return api().post(`/admin/panel/news/create`, info);
    },

    updateNewsInfo(newsId, info) {
        return api().put(`/admin/panel/news/${newsId}/update`, info);
    },

    uploadImagesForNews(files) {
        return api().post(`/admin/panel/news/file/upload`, files);
    },


    //files

    deleteFile(fileId) {
        return api().delete(`/files/${fileId}/delete`);
    },


    //general info

    updateGeneralInfo(info) {
        return api().post(`/admin/panel/general-info/store`, info);
    },


    //teams

    fetchTeams() {
        return api().get(`/admin/panel/teams/get`);
    },

    createMember(info) {
        return api().post(`/admin/panel/teams/store`, info);
    },

    updateMemberInfo(member_id, info) {
        return api().put(`/admin/panel/teams/${member_id}/update`, info);
    },

    deleteMember(teamId) {
        return api().delete(`/admin/panel/teams/${teamId}/delete`);
    },

    getMemberInfo(teamId) {
        return api().get(`/admin/panel/teams/${teamId}/get`);
    },

    //testimonials

    fetchListOfTestimonials() {
        return api().get(`/admin/panel/testimonials/get`);
    },

    createTestimonial(info) {
        return api().post(`/admin/panel/testimonials/store`, info);
    },

    updateTestimonial(testimonialId, info) {
        return api().put(`/admin/panel/testimonials/${testimonialId}/update`, info);
    },

    getTestimonial(testimonialId) {
        return api().get(`/admin/panel/testimonials/${testimonialId}/get`);
    },

    deleteTestimonials(testimonialId) {
        return api().delete(`/admin/panel/testimonials/${testimonialId}/delete`);
    },

    // clients

    fetchListOfClients() {
        return api().get(`/admin/panel/landing-clients/get`);
    },

    createClient(info) {
        return api().post(`/admin/panel/landing-clients/store`, info);
    },

    updateClientInfo(clientId, info) {
        return api().put(`/admin/panel/landing-clients/${clientId}/update`, info);
    },

    getClientInfo(clientId) {
        return api().get(`/admin/panel/landing-clients/${clientId}/get`);
    },


    deleteClient(clientId) {
        return api().delete(`/admin/panel/landing-clients/${clientId}/delete`);
    },

    //locations

    fetchLocations() {
        return api().get(`/admin/panel/locations/get`);
    },

    deleteLocation(locationId) {
        return api().delete(`/admin/panel/locations/${locationId}/delete`);
    },

    getLocationInfo(locationId) {
        return api().get(`/admin/panel/locations/${locationId}/get`);
    },

    createLocation(info) {
        return api().post(`/admin/panel/locations/store`, info);
    },

    updateLocationInfo(locationId, info) {
        return api().put(`/admin/panel/locations/${locationId}/update`, info);
    },










}
